import Image from 'next/image';

import { BannerFragment } from '@/fo/api/magento';
import { ContentWithFootnoteSup } from '@/fo/ui/mod/footnote/base';

import { UiKitSectionSeoTextProps } from '../lib/UiKitSectionSeoText';

export const mapSeoBannerFromData = (
  banner: BannerFragment | null
): UiKitSectionSeoTextProps => {
  const title = banner?.banner_data?.title;
  const image = banner?.banner_data?.desktop_image;

  return {
    title: image ? (
      <Image
        className="block h-14 w-auto items-start"
        alt={banner.banner_data?.title || ''}
        width={262}
        height={56}
        src={banner.banner_data?.desktop_image || ''}
      />
    ) : (
      title
    ),
    children: banner && (
      <ContentWithFootnoteSup
        as="div"
        id={banner.id}
        content={banner.banner_data?.small_text || ''}
      />
    )
  };
};
